<template>
	<div class="slideWrapper" :class="[{ active: active }, { inactive: !active }, { editMobile: editMobile }]"
		:style="{ '--duration': duration + 's' }">
		<div class="slide" :style="css" :class="backgroundTint != false ? backgroundTint : ''">
			<div v-if="image" id="desktop" class="image">
				<div className="contentDesktopWrapper">
					<div className="contentDesktop">
						<h1>{{ slide.title }}</h1>

						<p v-html="slide.html"></p>
						<ReadMore :readMore="readMore" :edit="edit" />
					</div>
				</div>
				<div><img :src="image.src" /></div>
			</div>

			<div v-if="!image" id="desktop">
				<div className="contentDesktop">
					<h1>{{ slide.title }}</h1>
					<p v-html="slide.html"></p>
					<ReadMore :readMore="readMore" :edit="edit" />
				</div>
			</div>

			<div id="mobile">
				<h1>{{ slide.title }}</h1>
				<div className="contentMobile">
					<img v-if="image" :src="image.src" />
					<p v-html="slide.html"></p>
				</div>
				<div v-if="readMore" id="readMore">
					<ReadMore :readMore="readMore" :edit="edit" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ReadMore from "@/components/slide/ReadMore.vue";

export default {
	name: "Slide",
	components: { ReadMore },
	props: {
		slide: Object,
		active: Boolean,
		edit: Boolean,
		editMobile: Boolean,
		iterations: Number,
		
	},
	data() {
		return {};
	},
	computed: {
		backgroundTint() {
			if (this.slide && this.slide.css && this.slide.css.backgroundTint > 0) {
				return "backgroundTint" + this.slide.css.backgroundTint;
			}

			return false;
		},
		css() {
			let css = {};

			if (this.slide && this.slide.css && this.slide.css.backgroundImage) {
				css.backgroundImage = this.slide.css.backgroundImage;
			}

			if (this.slide && this.slide.css && this.slide.css.backgroundSize) {
				css.backgroundSize = this.slide.css.backgroundSize;
			}

			return css;
		},
		image() {
			return this.slide.imageList && this.slide.imageList.length > 0 ? this.slide.imageList[0] : null;
		},

		readMore() {
			if (this.slide.readMore && this.slide.readMore.href) {
				const label =
					this.slide.readMore && this.slide.readMore.label && this.slide.readMore.label != "" ? this.slide.readMore.label : "Läs mer";
				const target =
					this.slide.readMore && this.slide.readMore.target && this.slide.readMore.target != "" ? this.slide.readMore.target : "_self";

				const title =
					this.slide.readMore && this.slide.readMore.href && this.slide.readMore.href != ""
						? "Läs mer på: " + this.slide.readMore.href
						: "Url saknas...";
				return { label, target, title, href: this.slide.readMore.href };
			}

			return null;
		},
		duration(){
			if (this.iterations == 0){
				return 0;
			}else{
				return 1;
			}
			
			
		}
	
	},

	methods: {},
	mounted() { },
	unmounted() { }
};
</script>

<style scoped>
/* wrapper */

div#slideView div#slideList div.slideWrapper {
	position: absolute;
	width: 100%;
	max-width: 1400px;
	height: 400px;

	color: white;
}


.slideWrapper.active {
	animation-name: animate-in;
}

.slideWrapper.inactive {
	animation-name: animate-out;
}

.slideWrapper {
	animation-duration: var(--duration, 1s);
	animation-timing-function: linear;
	animation-fill-mode: forwards;
}


@keyframes animate-out {
	0% {
		clip-path: inset(0 0 0 0);
	}

	100% {
		clip-path: inset(0 100% 0 0);
	}
}

@keyframes animate-in {
	0% {
		clip-path: inset(0 0 0 100%);
	}

	100% {
		clip-path: inset(0 0 0 0);
	}
}

/* slide */

div#slideView div#slideList div.slide {
	padding-left: 50px;
	padding-right: 50px;
	padding-top: 20px;
	padding-bottom: 20px;
	height: calc(400px - 40px);
	max-width: 1400px;
}

div#slideView div#slideList div.slide div#desktop {
	display: flex;
	gap: 10px;
	align-items: center;
}

div#slideView div#slideList div.slide div#mobile {
	display: none;
	height: calc(400px - 30px);
	flex-direction: column;
}

/* bugg fix 2024-09-23 fel bredd på bilden */
div#slideView div#slideList div.slideWrapper.active div.slide div#desktop.image div.contentDesktopWrapper {
	width: 50%;
}

div#slideView div#slideList div.slide div#desktop.image div.contentDesktopWrapper {
	flex-grow: 1;
}

div#slideView div#slideList div.slide div.contentDesktopWrapper div.contentDesktop {
	height: calc(400px - 40px);
	display: flex;
	flex-direction: column;
}

div#slideView div#slideList div.slide div#desktop div img {
	/*width: 100%; FP: 20241203 tog bort för att fungera på safari */
	height: auto;
	max-height: 360px;
}

div#slideView div#slideList div.slide div#mobile img {
	max-width: 100%;
}

div#slideList div.slideWrapper div.slide div#desktop div.contentDesktop p {
	flex-grow: 0;
	overflow-y: auto;
	overflow-x: hidden;
	padding-top: 0px;
	padding-bottom: 20px;
	margin: 0px;
}

div#slideList div.slideWrapper div.slide div#mobile div.contentMobile {
	flex-grow: 1;
		overflow-y: auto;
			overflow-x: hidden;
}

/*div#slideList div.slideWrapper div.slide h1 {
	text-shadow: black 0px 0px 20px;
	font-size: clamp(20px, calc(1.2vw + 20px), 40px);
}

div#slideList div.slideWrapper div.slide p {
	text-shadow: grey 0px 0px 10px;
	font-size: clamp(14px, calc(1.2vw + 10px), 20px);
}*/

div#slideList div.slideWrapper div.slide h1 {
	/*text-shadow:rgba(122, 121, 121, 0.9) 0px 0px 20px;*/
	color:white;

	filter: drop-shadow(0px 0px 7px rgba(0, 0, 0, 0.7));
	font-size: clamp(20px, calc(1.2vw + 20px), 40px);
}

div#slideList div.slideWrapper div.slide p {
	/*text-shadow: grey 0px 0px 10px;*/
	filter: drop-shadow(0px 0px 3px rgba(128, 128, 128, 0.9));
	font-size: clamp(14px, calc(1.2vw + 10px), 20px);
}

div#slideList div.slideWrapper div.slide.backgroundTint50 {
	background-color: rgba(0, 0, 0, 0.5);
	background-blend-mode: multiply;
}

div#slideList div.slideWrapper div.slide.backgroundTint25 {
	background-color: rgba(0, 0, 0, 0.25);
	background-blend-mode: multiply;
}

@media (max-width: 768px) {
	div#slideView div#slideList div.slide div#mobile {
		display: flex;
	}

	div#slideView div#slideList div.slide div#desktop {
		display: none;
	}
}

/* editMobile */

div#slideView div#slideList div.slideWrapper.editMobile {
	width: 400px;
	max-width: 400px;
}

div#slideView div#slideList div.slideWrapper.editMobile div.slide div#mobile {
	display: flex;
}

div#slideView div#slideList div.slideWrapper.editMobile div.slide div#desktop {
	display: none;
}
</style>